import { render, staticRenderFns } from "./power.vue?vue&type=template&id=78a122a0&scoped=true"
import script from "./power.vue?vue&type=script&lang=js"
export * from "./power.vue?vue&type=script&lang=js"
import style0 from "./power.vue?vue&type=style&index=0&id=78a122a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a122a0",
  null
  
)

export default component.exports